import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { WifiOffIcon } from 'base/components/Icon';
import theme from '../../../theme';
import { getOfflineDocumentIds } from '../../store/selectors';

const CacheOfflineToggle = ({ document, offlineDocumentIds }) => (
  <WifiOffIcon
    color={offlineDocumentIds.includes(document.id) ? theme.colors.primary : theme.colors.medium}
  />
);
CacheOfflineToggle.propTypes = {
  document: PropTypes.objectOf(PropTypes.any).isRequired,
  offlineDocumentIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

const mapStateToProps = (state) => ({
  offlineDocumentIds: getOfflineDocumentIds(state),
});

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CacheOfflineToggle);
